module.exports = __webpack_public_path__ + "static/media/Auth_Code_Grant.7963580f.png";